import React from 'react';

const WhiteThemeSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <rect x='0.5' width='38.6667' height='40' rx='5' fill='#FBFBFB' />
      <path
        d='M0.5 5C0.5 2.23858 2.73858 0 5.5 0H34.1667C36.9281 0 39.1667 2.23858 39.1667 5V10H0.5V5Z'
        fill='#682ECB'
      />
      <path
        d='M3.16797 15.3335C3.16797 14.2289 4.0634 13.3335 5.16797 13.3335H23.168C24.2725 13.3335 25.168 14.2289 25.168 15.3335V21.3335C25.168 22.4381 24.2725 23.3335 23.168 23.3335H3.16797V15.3335Z'
        fill='#ECECEC'
      />
      <path
        d='M15.168 28C15.168 26.8954 16.0634 26 17.168 26H35.168C36.2725 26 37.168 26.8954 37.168 28V36H17.168C16.0634 36 15.168 35.1046 15.168 34V28Z'
        fill='#ECECEC'
      />
    </svg>
  );
};

export default WhiteThemeSVG;
